<template>
  <!-- 1. 在这里增加 :size="size" -->
  <el-select v-model="selectValue" @change="changeOption"
             :disabled="disabled" :size="size" placeholder="请选择"
             class="common-width" :clearable="clearable" :filterable="filterable" :allowCreate="allowCreate">
    <el-option
      v-for="item in dictList"
      :key="item.value"
      :label="item.label"
      :value="item.value"/>
  </el-select>
</template>

<script>
import httpUtil from "../../utils/httpUtil";

export default {
  data() {
    return {
      selectValue: this.value,
      dictList: [],
    }
  },
  props: {
    /**
     * 默认选中值
     */
    value: {
      required: true
    },
    /**
     * 字典类型
     */
    dictCode: {
      type: String,
      required: true
    },
    /**
     * 是否可用
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示全部
     */
    all: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许清除
     */
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许搜索
     */
    filterable: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许创建
     */
    allowCreate: {
      type: Boolean,
      default: false
    },
    /**
     * 字典值类型 默认字符串
     */
    valueType: {
      required: false,
      type: String,
      default: 'String'
    },
    // 2. 新增 size 属性，默认可以是原有的默认大小或跟随外层表单
    size: {
      type: String,
      default: '' // 默认不填，由组件调用方或外层 el-form 决定，传入 'mini' 则生效
    }
  },
  watch: {
    value: function (newVal) {
      if (newVal != null && newVal !== '') {
        if (this.valueType === 'String') {
          this.selectValue = newVal + ""
        } else {
          this.selectValue = newVal
        }
      } else {
        if (this.valueType === 'String') {
          this.selectValue = ''
        } else {
          this.selectValue = null;
        }
      }
    },
  },
  created() {
    this.initData()
  },
  methods: {
    changeOption(item) {
      this.$emit("update:value", item);
      this.$emit('change', item);
    },
    async initData() {
      if (this.valueType === 'String') {
        this.selectValue = this.value + ''
      } else {
        this.selectValue = this.value
      }
      if (this.dictCode !== '') {
        this.dictList = this.$store.state.dictionary[this.dictCode]
        if (this.dictList === undefined || this.dictList.length === 0) {
          this.dictList = await httpUtil.get('/sys/dictionary/getDictByType', {'type': this.dictCode});
        }
        if (this.valueType !== 'String') {
          this.dictList.forEach(item => {
            item.value = parseInt(item.value)
          })
        }
        if (this.all) {
          if (this.valueType === 'String') {
            this.dictList.unshift({label: "全部", value: ""})
          } else {
            this.dictList.unshift({label: "全部", value: null})
          }

        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/select/dict-select.vue